import React from "react";
import { Box, Card, CardContent, Grid, Typography, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Slider from "react-slick";
import { CardHeading } from "../Common";
import "./SponsorsCard.css";
import { BASE_URL } from "../../../constant/apiURL";

const slide1 = require("../../../assets/images/green_nmc_1.png");

const cardStyles = makeStyles({
  sliderImage: {
    width: "auto",
    minWidth: "200px",
    height: "200px",
    objectFit: "contain",
  },
  sliderBox: {
    height: "90%",
    marginTop: "20px",
    marginBottom: "20px",
  },
  sliderContainer: {
    display: "flex !important",
    justifyContent: "center !important",
    alignItems: "center !important",
  },
});

function SponsorsCard(props) {
  const sponsorsList = props.sponsorsList;

  const classes = cardStyles();

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  const checkImage = (imageSrc) => {
    let img = `${BASE_URL}${imageSrc}`;

    return img;
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Card
          sx={{
            height: "auto",
            minHeight: "270x",
            paddingY: "10px",
          }}
        >
          <CardContent sx={{ height: "100%" }}>
            <Box>
              <CardHeading text="Sponsors" />
            </Box>
            <Slider {...settings} className={classes.sliderBox}>
              {sponsorsList?.map((item) => {
                return (
                  <div className={classes.sliderContainer}>
                    <img
                      src={item.logo ? checkImage(item.logo) : slide1}
                      className={classes.sliderImage}
                      alt="sponsors"
                    />
                  </div>
                );
              })}
            </Slider>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}

export default SponsorsCard;
